module.exports = __webpack_public_path__ + "images/logo-loudup-grey.png?f13a9";